import DeepLink from './DeepLink.view';

export default DeepLink;